var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.kit === "fa"
    ? _c("i", { class: ["fa" + _vm.weight, "fa-" + _vm.name] })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }